import Marionette from 'backbone.marionette';
import billDetailItemviewTmpl from '../templates/bill_detail_itemview.tpl';
export default Marionette.ItemView.extend({
  template: billDetailItemviewTmpl,
  className: "row",
  onShow: function () {
    var data = this.model.get("predictions_history").toJSON();
    data.sort(function (a, b) {
      return a.legislative_day - b.legislative_day;
    });
    var margin = {
        top: 30,
        right: 20,
        bottom: 40,
        left: 50
      },
      width = $('#predictions-chart').width() - margin.left - margin.right,
      height = 200 - margin.top - margin.bottom;
    var formatPercent = d3.format(".0%");
    var x = d3.scaleLinear().range([0, width]);
    var y = d3.scaleLinear().range([height, 0]);
    var xAxis = d3.axisBottom(x);
    var yAxis = d3.axisLeft(y).ticks(3).tickFormat(formatPercent);
    var line = d3.line().x(function (d) {
      return x(d.date);
    }).y(function (d) {
      return y(d.close);
    });
    var svg = d3.select("#predictions-chart").append("svg").attr("width", width + margin.left + margin.right).attr("height", height + margin.top + margin.bottom).append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    data.forEach(function (d) {
      d.date = +d.legislative_day;
      d.close = +d.prediction;
    });
    x.domain([1, 40]);
    y.domain([0, 1]);
    svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + height + ")").call(xAxis);
    svg.append("g").attr("class", "y axis").call(yAxis);
    svg.append("path").datum(data).attr("class", "line").attr("d", line);
    svg.append("line").attr("y1", 0).attr("y2", height).attr("x1", x(28)).attr("x2", x(28)).attr("class", "prediction-marker");
    svg.append("text").attr("transform", "translate(" + width / 2 + " ," + (height + margin.bottom) + ")").attr("class", "x-label").text("Legislative session days");
    svg.append("g").attr("transform", "translate(" + (x(28) - width / 160) + " ," + -20 + ")").attr("class", "model-change-label").style("fill", "#993333").append("text").text('Crossover');
    svg.append("g").attr("transform", "translate(" + (x(28) - width / 160) + " ," + -10 + ")").attr("class", "model-change-label").style("fill", "#993333").append("text").text('Day');
  }
});